var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "video-container " + _vm.cssClasses }, [
    _c("iframe", {
      attrs: {
        title: "Video player",
        width: "100%",
        height: "100%",
        allow:
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: "allowfullscreen",
        "data-src": _vm.src,
      },
    }),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video-consent-overlay" }, [
      _c("div", { staticClass: "video-consent-overlay-text" }, [
        _vm._v(
          "\n      Votre vidéo n'est pas affichée car vous avez refusé les cookies.\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }